
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-snackbar",
      function () {
        return require("private-next-pages/joy-ui/react-snackbar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-snackbar"])
      });
    }
  